const PRODUCTAPI = {
    ADDPRODUCT :`products/`,
    GETPRODUCT : (productid) => `/products/product/${productid}`,
    EDITPRODUCT: (productid) => `products/product/${productid}`,
    DELETEPRODUCT: (productid) => `products/product/${productid}`,
    ALLPRODUCTS: `products/products`
}

export default PRODUCTAPI;